import $ from 'jquery';
import license from 'license';
import state from 'state';

function recenter() {
    return $('#overlay > div').center();
}

$(window).on('resize', recenter);

export function closeOverlay() {
    var over = document.getElementById('overlay');
    over.className = '';
    over.onclick = null;
}

export function clickCloseOverlay(e) {
    var t = e.target; // Internet Explorer uses srcElement, but jQuery normalizes that
    if (t.nodeType == 3) t = t.parentNode; // Safari http://www.quirksmode.org/js/events_properties.html
    if (t.id == 'overlay' || t.id == 'closeOverlay') {
        e.preventDefault();
        closeOverlay();
    }
}

export function show(content, click) {
    var over = document.getElementById('overlay'),
        close = document.getElementById('closeOverlay');
    if (typeof str != 'string')
        $('#error').empty().append(content);
    else if (content.charAt(0) == '<')
        $('#error').html(content);
    else
        $('#error').text(content);
    over.className = 'error'; // not necessarily an error
    recenter();
    if (click !== false) {
        if (typeof click !== 'function')
            click = clickCloseOverlay;
        $(over).click(click);
    } else { // click === false, so this is a fatal error and should not be closed
        $(over).off('click');
        close.style.display = 'none';
    }
    state.pdf.triggerSafe('overlay', [ content ]);
}

export function error(content, click) {
    show(content, click);
    state.pdf.triggerSafe('error', [ content ]);
    if (click === false) // this is a fatal error and should stop flow
        throw new Error('Error: ' + content); // we want to exit any context
}

export function about() {
    var over = document.getElementById('overlay');
    $(over).click(clickCloseOverlay);
    over.className = 'about';
    recenter();
}

$('#licenseLink').click(function (e) {
    e.preventDefault();
    document.getElementById('overlay').className = 'license';
    var d = recenter();
    // work-around because else the children DIV can't calculate the height of the father (?)
    $('#license').css({
        width: d.width(),
        height: d.height()
    });
});

var div = $('<ul/>').appendTo('#license > div');
$.each(license, function (idx, el) {
    var li = $('<li/>').appendTo(div);
    li.append($('<a class=homepage/>').text(el.name).prop({ href: el.url }));
    var auth = el.author;
    if (!$.isArray(auth))
        li.append($('<div class=author/>').text(el.author));
    else
        $.each(auth, function (idx, auth) {
            li.append($('<div class=author/>').text(auth));
        });
    if (el.license) {
        var d = $('<div class=license/>').text('License: ').appendTo(li);
        $('<a class=license/>').text(el.license).prop({ href: el.licenseUrl }).appendTo(d);
    }
});
